export const daysOfWeek = [
  { value: '1', leftText: 'Monday' },
  { value: '2', leftText: 'Tuesday' },
  { value: '3', leftText: 'Wednesday' },
  { value: '4', leftText: 'Thursday' },
  { value: '5', leftText: 'Friday' },
  { value: '6', leftText: 'Saturday' },
  { value: '7', leftText: 'Sunday' },
]

export const timesOfDay = [
  { value: '00:00', leftText: '00:00' },
  { value: '01:00', leftText: '01:00' },
  { value: '02:00', leftText: '02:00' },
  { value: '03:00', leftText: '03:00' },
  { value: '04:00', leftText: '04:00' },
  { value: '05:00', leftText: '05:00' },
  { value: '06:00', leftText: '06:00' },
  { value: '07:00', leftText: '07:00' },
  { value: '08:00', leftText: '08:00' },
  { value: '09:00', leftText: '09:00' },
  { value: '10:00', leftText: '10:00' },
  { value: '11:00', leftText: '11:00' },
  { value: '12:00', leftText: '12:00' },
  { value: '13:00', leftText: '13:00' },
  { value: '14:00', leftText: '14:00' },
  { value: '15:00', leftText: '15:00' },
  { value: '16:00', leftText: '16:00' },
  { value: '17:00', leftText: '17:00' },
  { value: '18:00', leftText: '18:00' },
  { value: '19:00', leftText: '19:00' },
  { value: '20:00', leftText: '20:00' },
  { value: '21:00', leftText: '21:00' },
  { value: '22:00', leftText: '22:00' },
  { value: '23:00', leftText: '23:00' },
]
